var render, staticRenderFns
import script from "./AxIcon.vue?vue&type=script&lang=ts&"
export * from "./AxIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AxIcon.vue?vue&type=style&index=0&id=e7c9e9b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports